import React from "react";
import { PropertyValuationData } from "../../../../types/valuation";
import { formatCurrency } from "../../../../utils/formatters";

interface QuickStatsProps {
  propertyData: PropertyValuationData;
  colors: {
    text: string;
    primary: string;
  };
  metrics: {
    totalComps: number;
    recentSales: number;
    avgDaysOnMarket: number;
  };
  capRate: string;
}

export const QuickStats: React.FC<QuickStatsProps> = ({
  propertyData,
  colors,
  metrics,
  capRate,
}) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
      <div className="bg-white rounded-xl shadow-md p-6">
        <div className="text-sm mb-1" style={{ color: `${colors.text}99` }}>
          Property Value
        </div>
        <div className="text-2xl font-bold" style={{ color: colors.primary }}>
          {formatCurrency(propertyData.estimatedValue)}
        </div>
        <div className="mt-1 text-sm" style={{ color: `${colors.text}99` }}>
          {propertyData.propertyInfo?.livingSquareFeet
            ? `${formatCurrency(
                propertyData.estimatedValue /
                  propertyData.propertyInfo.livingSquareFeet
              )}/sqft`
            : "N/A"}
        </div>
      </div>

      <div className="bg-white rounded-xl shadow-md p-6">
        <div className="text-sm mb-1" style={{ color: `${colors.text}99` }}>
          Market Activity
        </div>
        <div className="text-2xl font-bold" style={{ color: colors.primary }}>
          {metrics.totalComps} Similar
        </div>
        <div className="mt-1 text-sm" style={{ color: `${colors.text}99` }}>
          {metrics.recentSales} Recent Sales
        </div>
      </div>

      <div className="bg-white rounded-xl shadow-md p-6">
        <div className="text-sm mb-1" style={{ color: `${colors.text}99` }}>
          Days on Market
        </div>
        <div className="text-2xl font-bold" style={{ color: colors.primary }}>
          {metrics.avgDaysOnMarket} days
        </div>
        <div className="mt-1 text-sm" style={{ color: `${colors.text}99` }}>
          Market Average
        </div>
      </div>

      <div className="bg-white rounded-xl shadow-md p-6">
        <div className="text-sm mb-1" style={{ color: `${colors.text}99` }}>
          Rental Potential
        </div>
        <div className="text-2xl font-bold" style={{ color: colors.primary }}>
          {formatCurrency(propertyData.demographics?.suggestedRent || 0)}
        </div>
        <div className="mt-1 text-sm" style={{ color: `${colors.text}99` }}>
          {capRate}% Cap Rate
        </div>
      </div>
    </div>
  );
};
